// https://medium.com/@pitipatdop/little-neat-trick-to-capture-click-outside-with-react-hook-ba77c37c7e82
import { useEffect } from 'react';
import type { ClickOutsideNode } from './types';

function onClickOutside(nodes: ClickOutsideNode | ClickOutsideNode[], onOutsideClick: (e: MouseEvent) => void): void {
  function handleClick(e: MouseEvent) {
    const targetNodes = Array.isArray(nodes) ? nodes : [nodes];
    if (targetNodes.some(n => !n.current || n.current.contains(e.target as Node))) return;
    onOutsideClick(e);
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClick);

    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  });
}

export default onClickOutside;
